import * as React from 'react';
import { DeprecatedSelect, ISelectOption } from '../../../../../web/components/DeprecatedSelect';
import { MoreIcon } from '../../../../../web/components/svgs/icons/MoreIcon';
import { styleSheet } from '../styles';

interface IProps {
	onClickToArchive?: () => void;
	onClickToBrowse?: () => void;
	onClickToRename?: () => void;
}

enum MoreOptions {
	Archive = 'archive',
	Browse = 'browse',
	Rename = 'rename',
}

export const CategoryCardOptions: React.FC<IProps> = ({ onClickToArchive, onClickToBrowse, onClickToRename }) => {
	const options: ISelectOption<MoreOptions>[] = [
		// {
		// 	dataContext: MoreOptions.Rename,
		// 	id: 'category-card-options-rename',
		// 	text: 'Rename',
		// 	type: 'blue',
		// },
		{
			dataContext: MoreOptions.Browse,
			id: 'category-card-options-browse',
			text: 'Browse Calls',
			type: 'blue',
		},
		{
			dataContext: MoreOptions.Archive,
			id: 'category-card-options-archive',
			text: 'Archive',
			type: 'blue',
		},
	];

	const handleSelectChange = (option: ISelectOption<MoreOptions>) => {
		switch (option.dataContext) {
			case MoreOptions.Archive:
				onClickToArchive();
				break;
			case MoreOptions.Browse:
				onClickToBrowse();
				break;
			case MoreOptions.Rename:
				onClickToRename();
				break;
			default:
				break;
		}
	};

	return (
		<DeprecatedSelect
			onOptionClick={handleSelectChange}
			options={options}
			selectedOptionTitle={<MoreIcon fillColor='' />}
			showCaret={false}
			styles={[styleSheet.moreMenu]}
			triggerStyles={[styleSheet.moreMenuTrigger]}
		/>
	);
};
